import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import { useCustomerValue } from "providers/CustomerContext";
import { useState } from "react";
import { getSKUCategoryOptions } from "services/data.internal.service";
import { getUserOptions } from "services/data.internal.service";
import BasicTabs from "ui-components/tabs/BasicTabs";
import InboundBillingReportConfiguration from "./inbound-billing-report-configuration";
import StorageBillingReportConfiguration from "./storage-billing-report-configuration";
import OutboundB2BBillingReportConfiguration from "./outbound-b2b-billing-report-configuration";
import OutboundB2CBillingReportConfiguration from "./outbound-b2c-billing-report-configuration";
import ReturnBillingReportConfiguration from "./return-billing-report-configuration";
import StuffingUnstuffingBillingReportConfiguration from "./stuffing-unstuffing-billing-report-configuration";
import VASBillingReportConfiguration from "./vas-billing-report-configuration";
import OTBillingReportConfiguration from "./ot-billing-report-configuration";
import ManagementFeesBillingReportConfiguration from "./managementfees-billing-report-configuration";
import { ListLayout } from "ui-components/Layout";
import SOLog from "layouts/views/outbound/sales-order/components/SOLog";
import { getTAFilterOptions } from "services/data.outbound.service";
import { CheckboxHeader, CheckboxCell } from "ui-components/tables/components/table";
import { useLocation } from "react-router-dom";
import React, { useRef } from "react";
import { MessageDialog } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import PackagingMaterialBillingReportConfiguration from "./packaging-material-billing-report-configutation";

const tabs = [
  "Storage",
  "Inbound",
  "Outbound (B2B)",
  "Outbound (B2C)",
  "Return",
  "Stuffing & Unstuffing",
  "Packaging Material",
  "VAS",
  "Management Fees",
  "OT",
];

function EditBillingList() {
  const {permissions, allowAll} = useTeamValue();
    const viewPricePermission =
    (Boolean(permissions["Team Role"]) && permissions["Team Role"].some(a => a === "access")) ||
       (Boolean(permissions["Billing Setup"]) &&
        permissions["Billing Setup"].findIndex((b) => b === "viewPrice") !== -1);
  const [status, setStatus] = useState("Storage");
  const { customerCode } = useCustomerValue();
  const [userOptions, setUserOptions] = useState([]);
  const [szOptions, setSZOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [salesOptions, setSalesOptions] = useState([]);
  const [isEdited, setIsEdited] = useState(false); 
  const [dialog, setDialog] = useState(null);
  const handleSaveRef = useRef(null); 
  const handleTabChange = (newStatus) => {
    console.log('handletabchange');
    if (isEdited) {
      console.log('isedited');
      setDialog(
        <MessageDialog
          title="You have unsaved changes. Do you want to save before exiting?"
          onClose={() => setDialog(null)}
          onOk={async () => {
            if (handleSaveRef.current) {
              console.log("Calling child's save function...");
              await handleSaveRef.current(); // Call handleSubmit from child
            }
            setIsEdited(false); // Reset flag
            setStatus(newStatus); // Switch tab
            setDialog(null);
          }}
          onCancel={() => {
            setIsEdited(false); // Discard changes
            setStatus(newStatus); // Switch tab
            setDialog(null);
          }}
        />
      );
    } else {
      setStatus(newStatus);
    }
  };
  const location = useLocation();
  const billingNo = location.state?.billingNo;
  const billingname = location.state?.billingName;
  console.log("Billing Number in edit billing:", billingNo);
  console.log("Billing Name in edit billing:", billingname);
  const [list, setList] = useState([]);
  const [alert, setAlert] = useState(null);

  const [logRequest, setLogRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const logProp = { open, setOpen, logRequest, setLogRequest };

  const columns = [
    {
      id: "select",
      cell: CheckboxCell,
    },
    {
      accessorKey: "orderDate",
      header: "Order Date",
      width: 150,
    },
    {
      accessorKey: "custOrdNbr",
      header: "Cust Order Number",
      width: 150,
    },
    {
      accessorKey: "referenceNo",
      header: "Reference No",
      width: 150,
    },
    {
      accessorKey: "category",
      header: "Category",
      width: 200,
    },
    {
      accessorKey: "marketplace",
      header: "Marketplace",
      width: 100,
    },
    {
      accessorKey: "shippingZone",
      header: "Shipping Zone",
      width: 150,
    },
    {
      accessorKey: "group",
      header: "Group",
      width: 60,
    },
    {
      accessorKey: "orderNumber",
      header: "Order Number",
      width: 150,
      cell: ({ row }) => {
        const { orderNumber } = row.original;
        return (
          <span
            style={{
              color: "#1A73E8",
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => {
              setOpen(true);
              setLogRequest({ orderNumber, customerCode });
            }}
          >
            {orderNumber}
          </span>
        );
      },
    },
    {
      accessorKey: "remark",
      header: "Remark",
    },
  ];

  useQuery({
    queryKey: ["user-options"],
    queryFn: () => getUserOptions(),
    onSuccess: (data) => setUserOptions(data.data.data),
  });

  useQuery({
    queryKey: ["filter-options", { customerCode }],
    queryFn: () => getTAFilterOptions({ customerCode }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      const { shippingZone, sales } = data.data.data;
      setSZOptions(shippingZone);
      setSalesOptions(sales);
    },
  });
  useQuery({
    queryKey: ["category-options", { customerCode }],
    queryFn: () => getSKUCategoryOptions({ customerCode }),
    onSuccess: (data) => setCategoryOptions(data.data.data),
    enabled: Boolean(customerCode),
  });

  const render = () => {
    let task;
    switch (status) {
      case "Storage":
        task = (
          <StorageBillingReportConfiguration
            columns={columns}
            customerCode={customerCode}
            userOptions={userOptions}
            szOptions={szOptions}
            categoryOptions={categoryOptions}
            salesOptions={salesOptions}
            list={list}
            setList={setList}
            setAlert={setAlert}
            activeTab={"Storage"}
            billingname={billingname} // Pass as prop
            //setBillingname={setBillingname} // Allow child to update
            billingNo={billingNo}
            isEditMode={true}
            isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
          />
        );
        break;

      case "Inbound":
        task = <InboundBillingReportConfiguration  columns={columns}
        customerCode={customerCode}
        userOptions={userOptions}
        szOptions={szOptions}
        categoryOptions={categoryOptions}
        salesOptions={salesOptions}
        list={list}
        setList={setList}
        setAlert={setAlert}
        activeTab={"Inbound"}
        billingname={billingname} // Pass as prop
           // setBillingname={setBillingname} // Allow child to update
           billingNo={billingNo}
           isEditMode={true}
           isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;
        case "Outbound (B2B)":
          task = <OutboundB2BBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"Outbound (B2B)"}
          billingname={billingname} // Pass as prop
          billingNo={billingNo}
           isEditMode={true}
          isEdited={isEdited}
              setIsEdited={setIsEdited}
              onSubmit={(handleSubmit) => {
                handleSaveRef.current = handleSubmit; // Store reference to child's function
              }}
              viewPricePermission={viewPricePermission}
          />;
          break;
  
        case "Outbound (B2C)":
          task = <OutboundB2CBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"Outbound (B2C)"}
          billingname={billingname} // Pass as prop
          billingNo={billingNo}
           isEditMode={true}
          isEdited={isEdited}
              setIsEdited={setIsEdited}
              onSubmit={(handleSubmit) => {
                handleSaveRef.current = handleSubmit; // Store reference to child's function
              }}
              viewPricePermission={viewPricePermission}
          />;
          break;

        case "Return":
        task = <ReturnBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"Return"}
        billingname={billingname} // Pass as prop
        billingNo={billingNo}
        isEditMode={true}
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
            //setBillingname={setBillingname} // Allow child to update
            />;
        break;

        case "Packaging Material":
      task = <PackagingMaterialBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"PackagingMaterial"}
      billingname={billingname} // Pass as prop
      billingNo={billingNo}
      isEditMode={true}
      isEdited={isEdited}
          setIsEdited={setIsEdited}
          onSubmit={(handleSubmit) => {
            handleSaveRef.current = handleSubmit; // Store reference to child's function
          }}
          viewPricePermission={viewPricePermission}
      />;
      break;

        case "Stuffing & Unstuffing":
        task = <StuffingUnstuffingBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"StuffingUnstuffing"}
        billingname={billingname} // Pass as prop
        billingNo={billingNo}
        isEditMode={true}
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        //setBillingname={setBillingname} // Allow child to update
        />;
        break;

      case "VAS":
        task = <VASBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"VAS"}
        billingname={billingname} // Pass as prop
        billingNo={billingNo}
        isEditMode={true}
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        //setBillingname={setBillingname} // Allow child to update
        />;
        break;

      case "Management Fees":
        task = <ManagementFeesBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"ManagementFees"}
        billingname={billingname} // Pass as prop
        billingNo={billingNo}
        isEditMode={true}
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        //setBillingname={setBillingname} // Allow child to update
        />;
        break;

      case "OT":
        task = <OTBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"OT"}
        billingname={billingname} // Pass as prop
        billingNo={billingNo}
        isEditMode={true}
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        //setBillingname={setBillingname} // Allow child to update
        />;
        break;

      // case "Pickslip (Location)":
      //   task = (
      //     <PickslipLocation
      //       customerCode={customerCode}
      //       userOptions={userOptions}
      //       setAlert={setAlert}
      //     />
      //   );
      //   break;
      // case "Allocation Queue":
      //   task = <AllocationQueue customerCode={customerCode} />;
      //   break;
      // case "Amend Pickslip":
      //   task = <Demo2 customerCode={customerCode} />;
      //   break;
    }

    return task;
  };
  return (
    <ListLayout lg={12}>
      <SOLog {...logProp} />
      {dialog}
      <MDBox my={3}>
        {alert}
        <BasicTabs tabs={tabs} status={status} setStatus={handleTabChange} />

        <MDBox>{render()}</MDBox>
      </MDBox>
    </ListLayout>
  );
}

export default EditBillingList;
